import React, { PropTypes } from 'react';
import { DragSource, DropTarget } from 'react-dnd';

const style = {
    cursor: 'move'
};

class ContentElement extends React.Component {


    static get defaultProps() {
        return {
            title: null,
            data: {},
        }
    }

    render() {

        const { isDragging, connectDragSource, connectDropTarget, title, data } = this.props;
        const opacity = isDragging ? 0 : 1;

        let thumb = null;
        if (data.type && data.type === 'image' && data.thumb) {
            thumb = <img src={data.thumb} width="60" height="60" cellPadding="10" />
        }

        return connectDragSource(
            <div className="panel-body" style={{...style, opacity}}>
                {thumb}
                {title}
            </div>
        )
    }
}

ContentElement.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
}

const contentElementSource = {

    beginDrag(props) {

        return {
            id: props.id,
            index: props.index,
            data: props.data,
            source: 'contentElement',
        };
    },

    endDrag(props, monitor) {

        //const item = monitor.getItem();
        //const dropResult = monitor.getDropResult();

        //if ( dropResult && dropResult.listId !== item.listId ) {
        //    props.removeCard(item.index);
        //}
    }
};

// export default ContentElement;
export default DragSource("CONFIGURATOR_DND", contentElementSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}))(ContentElement)


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/ContentElement.react.jsx